<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/blogs",
		    "name": "Blogs"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a></li>
                    <li>></li>
                    <li>Blogs</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<!-- Breadcrumb -->
<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-8 col-md-8 col-xl-8">
                <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
                    <h1 id="bnr-heading">{{heading}}</h1>
                    <h2 id="bnr-subheading">{{subheading}}</h2>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                    <!-- header background -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
            </div>
        </div>
    </div>
</div>

<!-- Page Conttent -->
<main class="page-content">

    <!-- Start Post Carousel Style-->
    <div class="section-post-carousel section-pt section-pb-60">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">

                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4">
                            <a routerLink="/secure-your-financial-transactions">
                                <img src="assets/images/blog/secure-your-financial-transactions.jpeg"
                                    alt="SIM Binding solution protect SIM Swap Frauds">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a routerLink="/secure-your-financial-transactions">Secure your Financial Transactions with Advanced SIM & Device Binding Solution 
                                </a></h4>
                            <ul class="meta d-flex">
                                <!-- <li><i class="zmdi zmdi-calendar-check"></i>August 14, 2023</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Harish Ramasamy</li> -->
                            </ul>
                            <p class="brcontent">
                                A recent report from the Reserve Bank of India (RBI) highlighted a 
                                    significant rise in fraud cases within the banking and financial sector 
                                    during financial year 2022-23. RBI emphasized...
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/secure-your-financial-transactions">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>

                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4">
                            <a routerLink="/sim_binding_solution_protect_sim_swap_frauds">
                                <img src="assets/images/blog/sim-binding-solution-protect-sim-swap-frauds.jpeg"
                                    alt="SIM Binding solution protect SIM Swap Frauds">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a routerLink="/sim_binding_solution_protect_sim_swap_frauds">How AppBind SIM Binding solution protect SIM Swap Frauds? 
                                </a></h4>
                            <ul class="meta d-flex">
                                <!-- <li><i class="zmdi zmdi-calendar-check"></i>August 14, 2023</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Harish Ramasamy</li> -->
                            </ul>
                            <p class="brcontent">
                                By the end of 2023, each day, every city in India is reporting SIM swap fraud cases. 
                                SIM swap frauds are increasing due to rising reliance on mobile phone-based authentication methods....
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/sim_binding_solution_protect_sim_swap_frauds">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>

                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4">
                            <a routerLink="/sim-and-device-binding-mitigating">
                                <img src="assets/images/blog/sim_device_binding_mitigating.webp"
                                    alt="Mitigating Identity Theft & Frauds for
                                    Banking & Financial Apps">
                            </a>
                        </div>
                        <div  class="col-md-8 ptc-content">
                            <h4><a routerLink="/sim-and-device-binding-mitigating">SIM & Device Binding: Mitigating Identity Theft & Frauds for
                                Banking & Financial Apps
                                </a></h4>
                            <ul class="meta d-flex">
                                <!-- <li><i class="zmdi zmdi-calendar-check"></i>August 14, 2023</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Harish Ramasamy</li> -->
                            </ul>
                            <p class="brcontent">
                                Financial and Mobile Banking Apps have become an integral part of daily lives in today's digital
                                world. India clocked 11 billion UPI transactions worth Rs. 17.16 lakh crore in October 2023...
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/sim-and-device-binding-mitigating">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>

                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4">
                            <a routerLink="/safeguard-against-banking-and-financial-frauds-through-phishing-links">
                                <img src="assets/images/blog/appbind_blog.webp"
                                    alt="Safeguard Against Banking & Financial Frauds Through Phishing Links">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a routerLink="/safeguard-against-banking-and-financial-frauds-through-phishing-links">Safeguard Against Banking & Financial Frauds Through Phishing Links</a></h4>
                            <ul class="meta d-flex">
                                <!-- <li><i class="zmdi zmdi-calendar-check"></i>August 14, 2023</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Harish Ramasamy</li> -->
                            </ul>
                            <p class="brcontent">
                                In today’s digitally driven world, where technology facilitates seamless communication and transactions, the prevalence of phishing attacks has become a significant concern ...
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/safeguard-against-banking-and-financial-frauds-through-phishing-links">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>

                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4">
                            <a routerLink="/deviceandsimbinding">
                                <img src="assets/images/blog/deviceandsimbinding.jpeg"
                                    alt="Comply with National Payments Corporation of India's (NPCI's) latest master circular for Device and SIM Binding">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a routerLink="/deviceandsimbinding">Comply with National Payments Corporation of India's (NPCI's) latest master circular for Device and SIM Binding </a></h4>
                            <ul class="meta d-flex">
                                <!-- <li><i class="zmdi zmdi-calendar-check"></i>August 14, 2023</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Harish Ramasamy</li> -->
                            </ul>
                            <p class="brcontent">
                                In recent years, Unified Payments Interface (UPI) has transformed digital payment ecosystem and has emerged as a preferred mode of financial transactions. UPI has clocked ...
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/deviceandsimbinding">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>

                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4">
                            <a routerLink="/protecting-sensitive-mobile-apps-on-rooted-device">
                                <img src="assets/images/blog/rooted_devices.webp"
                                    alt="Protecting Sensitive Mobile Apps on Rooted Devices">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a routerLink="/protecting-sensitive-mobile-apps-on-rooted-device">Protecting Sensitive Mobile Apps on Rooted Devices</a></h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i>August 14, 2023</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Harish Ramasamy</li>
                            </ul>
                            <p class="brcontent">
                                Rooting is the act of obtaining root or administrative access to the Android operating system, which is typically restricted for security reasons.When a device is rooted, the user gain...
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/protecting-sensitive-mobile-apps-on-rooted-device">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>
                    
                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4">
                            <a routerLink="/rasp-in-era-of-devsecops">
                                <img src="assets/images/blog/devsecops.webp"
                                    alt="Runtime Application Self-Protection (RASP) for Mobile App Security in the Era of DevSecOps">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a routerLink="/rasp-in-era-of-devsecops">Runtime Application Self-Protection (RASP) for Mobile App Security in the Era of DevSecOps</a></h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i>August 7, 2023</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Pankaj Patankar</li>
                            </ul>
                            <p class="brcontent">
                                In today&#39;s fast-paced and ever-evolving digital threat landscape, mobile app security has become a top priority for corporates. In 2022, 28 Bn Mobile apps have been downloaded...
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/rasp-in-era-of-devsecops">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>

                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4">
                            <a routerLink="/risk_and_impacts_of_accessibility_permission">
                                <img src="assets/images/blog/accessibility_permission.webp"
                                    alt="Ensure a Safe and Secure Mobile Banking Experience with Zero Trust Device and SIM Binding Solution">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a routerLink="/risk_and_impacts_of_accessibility_permission">The Risk and Impact of
                                    Accessibility Permission on Mobile Apps</a></h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i>June 6, 2023</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Zameer Hussain</li>
                            </ul>
                            <p class="brcontent">
                                The accessibility permission is a feature in mobile operating systems that allow
                                applications to
                                access user interactions with the device&#39;s interface enabling assistive technologies
                                for...
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/risk_and_impacts_of_accessibility_permission">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>

                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4">
                            <a routerLink="/reverse-engineering-on-android-mobile-aplication">
                                <img src="assets/images/blog/reverse_eng.webp"
                                    alt="Ensure a Safe and Secure Mobile Banking Experience with Zero Trust Device and SIM Binding Solution">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a routerLink="/reverse-engineering-on-android-mobile-aplication">Reverse Engineering on
                                    Android Mobile Applications: How It Works and Business Impacts</a></h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i>May 10, 2023</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Jegan Saravanan</li>
                            </ul>
                            <p class="brcontent">
                                Android Mobile Apps are compiled as APKs / AABs, which can be decompiled with certain
                                tools and techniques (APKtool, JADX, Dex2jar, etc.,). The main objective of Reverse
                                Engineering is...
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/reverse-engineering-on-android-mobile-aplication">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>

                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4">
                            <a routerLink="/zerotrustdeviceandsimbindingsolution">
                                <img src="assets/images/blog/appbindblog.webp"
                                    alt="Ensure a Safe and Secure Mobile Banking Experience with Zero Trust Device and SIM Binding Solution">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a routerLink="/zerotrustdeviceandsimbindingsolution">Ensure a Safe and Secure Mobile
                                    Banking Experience with Zero Trust Device and SIM Binding Solution</a></h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i>Apr 10, 2023</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Mohanraj Selvaraj</li>
                            </ul>
                            <p class="brcontent">
                                Identity theft is one of the oldest financial fraud techniques and is a growing concern
                                in the
                                current digital age as more and more personal information is being stored...
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/zerotrustdeviceandsimbindingsolution">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>
                    <!-- Start Single Post -->
                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4">
                            <a routerLink="/protect-your-sensitive-mobile-apps">
                                <img src="assets/images/blog/protect_your_sensitive.webp"
                                    alt="Protect Your Sensitive Mobile Apps from Screen Overlay">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a routerLink="/protect-your-sensitive-mobile-apps">Protect Your Sensitive Mobile Apps
                                    from Screen Overlay</a></h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i>Mar 6, 2023</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Pravin Velmurugan</li>
                            </ul>
                            <p class="brcontent">
                                Screen Overlay is simply one Screen overlapping another. It has been
                                maliciously exploited by attackers over the web for a long time. And now the
                                threat...
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/protect-your-sensitive-mobile-apps">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Post --><!-- Start Single Post -->
                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4">
                            <a routerLink="/four-ways-to-improve-the-mobile-application">
                                <img src="assets/images/blog/4ways_to_improve_mobile_application.webp"
                                    alt="Protect from unsecured Wi-Fi security">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a routerLink="/four-ways-to-improve-the-mobile-application">5 Ways To Improve The
                                    Mobile
                                    Application Security Of Mobile Banking Apps</a></h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i>Dec 2, 2022</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Admin</li>
                            </ul>
                            <p class="brcontent">
                                Mobile banking applications have seen a remarkable rise in India post the lockdown
                                phase. People prefer to use the banking application...
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/four-ways-to-improve-the-mobile-application">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Post -->
                    <!-- Start Single Post -->
                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4">
                            <a routerLink="/six-important-tips-for-mobile-data">
                                <img src="assets/images/blog/six_important_tips.webp"
                                    alt="Protect from unsecured Wi-Fi security">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a routerLink="/six-important-tips-for-mobile-data">6 Important Tips to Secure Your
                                    Personal Data on Smartphones</a></h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i>Sep 23, 2022</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Ankur Gupta</li>
                            </ul>
                            <p class="brcontent">
                                The exponential growth in the adoption of smartphones has brought a behavioural change
                                in the masses.Today, Mobile Apps are at the centre...
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/six-important-tips-for-mobile-data">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Post -->
                    <!-- Start Single Post -->
                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4">
                            <a routerLink="/mobile-payments-application-security-controls">
                                <img src="assets/images/blog/mobile-payments-application-security-control.png"
                                    alt="Protect from unsecured Wi-Fi security">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a routerLink="/mobile-payments-application-security-controls">Mobile Payments
                                    Application Security Controls: RBI Guidelines You Must Know</a></h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i>Aug 8, 2022</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Sunita Handa</li>
                            </ul>
                            <p class="brcontent">
                                With the increase in mobile app users & transactions and the corresponding increase in
                                mobile app-related cyber threats, the requirement...
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/mobile-payments-application-security-controls">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Post -->

                    <!-- Start Single Post -->
                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4">
                            <a routerLink="/protect-mobile-apps-from-unsecured-wifi">
                                <img src="assets/images/blog/protect-mobile-app-usecured-wifi.webp"
                                    alt="Protect from unsecured Wi-Fi security">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a routerLink="/protect-mobile-apps-from-unsecured-wifi">Protect Your Mobile
                                    Apps
                                    From Unsecured Networks or Wi-Fi</a></h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i>Mar 4, 2022</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Admin</li>
                            </ul>
                            <p class="brcontent">
                                As per recent studies, India sees an 845% jump in cyber attacks on mobile devices
                                between October 2020 and March 2021.
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/protect-mobile-apps-from-unsecured-wifi">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Post -->
                    <!-- Start Single Post -->
                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4 mt-3">
                            <a routerLink="/protect-your-corporate-mobile-app-from-reverse-engineering">
                                <img src="assets/images/blog/protect-your-corporate-mobile-app-from-reverse-engineering.webp"
                                    alt="Enhance your Android Phone Security">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a class="h4-title"
                                    routerLink="/protect-your-corporate-mobile-app-from-reverse-engineering">Protect
                                    Your Corporate
                                    Mobile App From Reverse Engineering</a></h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i> Jan 15, 2022</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Admin</li>
                            </ul>
                            <p class="brcontent">Reverse engineering is a method used to achieve various targets. It forms the basis of
                                many forms of cyber attacks....
                            </p>
                            <div class="post-btn">
                                <!-- <a class="readmore-btn btn btn-circle" routerLink="/protect-your-corporate-mobile-app-from-reverse-engineering">READ MORE</a> -->
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/protect-your-corporate-mobile-app-from-reverse-engineering">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Post -->
                    <!-- Start Single Post -->
                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4 mt-3">
                            <a routerLink="/how-mobile-app-spoofing-impacts-business">
                                <img src="assets/images/blog/how-mobile-app-spoofing-impacts-business.webp"
                                    alt="Enhance your Android Phone Security">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a class="h4-title" routerLink="/how-mobile-app-spoofing-impacts-business">How Mobile
                                    App Spoofing Impacts
                                    Business</a></h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i> Dec 12, 2021</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Admin</li>
                            </ul>
                            <p class="brcontent">An organized spoofing attack involves a hacker acting as a legitimate entity and
                                targeting a customer of the same enterprise....
                            </p>
                            <div class="post-btn">
                                <!-- <a class="readmore-btn btn btn-circle" routerLink="/how-mobile-app-spoofing-impacts-business">READ
                  MORE</a> -->
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/how-mobile-app-spoofing-impacts-business">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Post -->
                    <!-- Start Single Post -->

                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4 mt-3">
                            <a routerLink="/five-ways-to-enhance-your-android-phone-security">
                                <img src="assets/images/blog/five-ways-to-enhance-your-android-phone-security.webp"
                                    alt="Enhance your Android Phone Security">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a class="h4-title" routerLink="/five-ways-to-enhance-your-android-phone-security">5
                                    Ways to Enhance Your Android Phone
                                    Security</a></h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i>Nov 10, 2021</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Admin</li>
                            </ul>
                            <p class="brcontent">Does your heart skip a beat when your phone slips from the pocket? We know how fragile
                                our mobile phones can be...</p>
                            <div class="post-btn">
                                <!-- <a class="readmore-btn btn btn-circle" routerLink="/five-ways-to-enhance-your-android-phone-security">READ MORE</a> -->
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/five-ways-to-enhance-your-android-phone-security">READ MORE</a>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Post -->
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <!-- Start Single Post -->
                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4 mt-3">
                            <a routerLink="/smartphone-antivirus-need-of-the-hour">
                                <img src="assets/images/blog/smartphone-antivirus-need-of-the-hour.webp"
                                    alt="Smartphone Antivirus">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a class="h4-title" routerLink="/smartphone-antivirus-need-of-the-hour">Smartphone
                                    Antivirus: Need of The Hour</a>
                            </h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i> Oct 18, 2021 </li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Admin</li>
                            </ul>
                            <p class="brcontent">Antiviruses have been around for long, it became integral for computers but as most work
                                is getting done through cell phones...</p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/smartphone-antivirus-need-of-the-hour">READ MORE</a>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Post -->
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <!-- Start Single Post -->
                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4 mt-3">
                            <a routerLink="/seven-must-have-apps-on-your-smartphone">
                                <img src="assets/images/blog/seven-must-have-apps-on-your-smartphone.webp"
                                    alt="Apps on Your Smartphone">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a class="h4-title" routerLink="/seven-must-have-apps-on-your-smartphone">Seven Must
                                    Have Apps on Your Smartphone</a>
                            </h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i>Sep 15, 2021</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Admin</li>
                            </ul>
                            <p class="brcontent">Travelling, eating, entertainment, banking, shopping, you name it and your phone has got
                                your back....
                            </p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/seven-must-have-apps-on-your-smartphone">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Post -->
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <!-- Start Single Post -->
                    <div class="post-carousel mb-30 row">
                        <div class="thumb col-md-4 mt-3">
                            <a routerLink="/enhancing-mobile-app-security-through-rasp">
                                <img src="assets/images/blog/mobile-app-security-rasp.webp"
                                    alt="Enhancing Mobile App Security through RASP">
                            </a>
                        </div>
                        <div style="padding-top: 0;" class="col-md-8 ptc-content">
                            <h4><a class="h4-title" routerLink="/enhancing-mobile-app-security-through-rasp">Enhancing
                                    Mobile App Security Through
                                    RASP</a></h4>
                            <ul class="meta d-flex">
                                <li><i class="zmdi zmdi-calendar-check"></i>Aug 20, 2021</li>
                                <li><i class="zmdi zmdi-account-calendar"></i> By : Admin</li>
                            </ul>
                            <p class="brcontent">The influx of digital means has revolutionized the world! All hail to the Digital
                                bonanza. Buying, selling, and processing...</p>
                            <div class="post-btn">
                                <a class="readmore-btn btn btn-rectengle"
                                    routerLink="/enhancing-mobile-app-security-through-rasp">READ
                                    MORE</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Single Post -->
        </div>
    </div>
    <!-- End Post Carousel  Style-->
    <!-- Start Floating Buttons -->
    <!-- End Floating Buttons -->
</main>
<!--// Page Conttent -->